import {
  deleteSSRCookie,
  getSSRCookie,
  setSSRCookie,
  TCookieOptions,
} from '@/common/cookies';
import { TRedirectData } from '@/modules/register/types';
import { returnRegisterRedirectUrl } from '@/modules/register/utils';

const COOKIE_NAME = 'loginRedirectUrl';
const FALLBACK_URL = '/';

export const setLoginRedirectUrl = (
  res: TServerSideResponse,
  value: string,
  options?: TCookieOptions
) => {
  if (
    !value ||
    value === FALLBACK_URL ||
    value.startsWith('/api') ||
    value.includes('.')
  ) {
    return;
  }

  setSSRCookie(res, COOKIE_NAME, value, options);
};

export type TLoginRedirectData = TRedirectData & {
  backUrl: string | undefined;
};

export const getLoginRedirectUrl = (
  { req, res }: TServerSideContext,
  redirectData?: TLoginRedirectData
): string => {
  const { backUrl, nextStep } = redirectData || {};

  const loginRedirectUrl =
    backUrl || getSSRCookie(req, COOKIE_NAME) || FALLBACK_URL;
  deleteSSRCookie(res, COOKIE_NAME);

  const shouldRedirectToRegister = nextStep;

  if (shouldRedirectToRegister) {
    return returnRegisterRedirectUrl(nextStep);
  }
  return loginRedirectUrl;
};
